export default __webpack_public_path__ + "static/media/inspire_web-sm@2x.4a9ca424.jpg";